export const gaidoWebImages="https://gaidoweb.s3.ap-south-1.amazonaws.com/"